<template>
	<div class="tpl account-safe-wrap">
		<mt-header title="账号与安全" fixed>
			<router-link :to="{name:'my-setting'}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
		</mt-header>
		<div class="item-list">
			<ul @click="wraning">
				<li>
					<span class="name">修改密码</span>
					<span class="value"><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
				</li>
				<li>
					<span class="name">修改手机号</span>
					<span class="value"><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
				</li>
				<li>
					<span class="name">支付密码</span>
					<span class="value"><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
				</li>
				<li>
					<span class="name">清空聊天记录</span>
					<span class="value"><img src="../../assets/img/common/ic_arrow_enter@2x.png"/></span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default{
		name:"account-safe",
		methods:{
			wraning(){
				this.$toast({
					message:"请至鱼水缘App进行此操作",
					position:"bottom",
					duration:3000
				})
			}
		}
	}
</script>

<style scoped>
	.account-safe-wrap{
		padding-top: 2.5rem;
	}
	.item-list li{
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #fff;
		border-bottom: 1px solid #f3f3f3;
		padding: 0.3rem 1rem;
		font-size: 0.9rem;
		color: #282828;
	}
	.item-list li img{
		width: 1.8rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/AccountSafe.vue